import axios from "axios";

export default axios.create({
    baseURL: "https://cl.frontierseeker.com/Registration/api/",
});
